<template>
	<div class="page-wrapper">
		<header class="header arrow-down" role="banner">
			<div class="logo"><a title="Zur Index-Seite aller Beispiele" href="../../index.html">RWD-Beispiele</a></div>
		</header>
		<nav id="nav" class="nav arrow-down">
			<ul id="navMain" class="main-nav">
				<li><a href="../../index.html" title="Zur Index-Seite aller Beispiele">Startseite</a></li>
				<li><a href="https://rwd-praxis.de" target="_blank" title="Öffnet Website zum Buch in einem neuen Fenster">Buch</a></li>
				<li class="main-nav__item-act"><b>Beispiel</b></li>
				<li><a href="https://www.rheinwerk-verlag.de/responsive-webdesign_4395/" target="_blank" title="Öffnet www.rheinwerk-verlag.de in einem neuen Fenster">Verlag</a></li>
				<li><a href="#" title="Dummy-Link">Über Uns</a></li>
				<li><a href="#" title="Dummy-Link">Impressum</a></li>
			</ul>
		</nav>
		<div class="main-wrapper">
			<main class="main-content" role="main">
				<h1>+ Version für große Desktop-Bildschirme</h1>
				<p class="teasertext">In diesem Beispiel wurden die Styles für den dritten Breakpoint ergänzt. Generell ändert sich jetzt nichts mehr bei der Anordnung der einzelnen Elemente, jedoch wird die Darstellungsbreite begrenzt um zu vermeiden, dass Textzeilen zu lang werden.</p>
				<section class="section section-1 blindtext">
					<h2>1. Abschnitts Überschrift</h2>
					<p>Li nov lingua franca va esser plu simplic e <span class="highlight">* regulari quam li existent Europan *</span> lingues. It va esser tam simplic quam Occidental in fact, it va esser Occidental. A un Angleso it va semblar un simplificat Angles, quam un skeptic Cambridge amico dit me que Occidental es.Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc, litot Europa usa li sam vocabular. Li lingues differe solmen in li grammatica, li pronunciation e li plu commun vocabules. Omnicos directe al desirabilite de un nov lingua franca: On refusa continuar payar custosi traductores. At solmen va esser necessi far uniform grammatica, pronunciation e plu sommun paroles.</p>
				</section>
				<section class="section section-2 blindtext">
					<h2>2. Abschnitts Überschrift</h2>
					<p>A un Angleso it va semblar un simplificat Angles, quam un skeptic Cambridge amico dit me que Occidental es.Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc, litot Europa usa li sam vocabular. Li lingues differe solmen in li grammatica, li pronunciation e li plu commun vocabules. Omnicos directe al desirabilite de un nov lingua franca: On refusa continuar payar custosi traductores. At solmen va esser necessi far uniform grammatica, pronunciation e plu sommun paroles. Li nov lingua franca va esser plu simplic e regulari quam li existent Europan lingues. <a href="#">It va esser tam simplic quam Occidental in fact, it va esser Occidental.</a></p>
				</section>
			</main>
			<aside class="aside" role="complementary">
				<h3>Über das Buch</h3>
				<p>Die 3. Auflage von "Responsive Webdesign" von Andrea Ertel und Kai Laborenz erschien im Frühjahr 2017 im Rheinwerk Verlag.</p>
				<p>Das Buch zeigt Ihnen, wie Sie von Beginn an in flexiblen Strukturen denken, Media Queries professionell einsetzen und Usability-Anforderungen umsetzen.
					<br> In zahlreichen Beispielprojekten aus der Praxis werden Layout-, Navigations- und Content-Strategien erläutert.</p>
				<p>"Responsive Webdesign" erschien erstmalig im Dezember 2013 im Galileo Press Verlag.</p>
			</aside>
		</div>
		<footer class="footer" role="contentinfo">
			<p class="copy">Responsive Webdesign - erschienen im <a href="https://www.rheinwerk-verlag.de/responsive-webdesign_4395/" target="_blank" title="Öffnet www.rheinwerk-verlag.de in einem neuen Fenster">Rheinwerk Verlag</a> &copy;&nbsp;2013&nbsp;-&nbsp;2017</p>
		</footer>
	</div>

</template>

<script>
export default {
  name: "ResponsiveLayout",
  props: [],
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";

</style>



// WEBPACK FOOTER //
// src/components/global/responsive-layout.vue